import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect, useState } from 'react';
import { Auth } from '../../providers/AuthProvider';
import { Routes } from '../../routes/routes';
import { useDarkMode } from '../../hooks/useDarkMode/useDarkMode';
import { darkTheme } from '../../themes/darkTheme';
import { defaultTheme } from '../../themes/defaultTheme';
import { awsConfigure } from '../../utils/awsConfigure';
import * as config from '../../config/env-config.json';
import { useAmplify } from '../../hooks/useAmplify/useAmplify';
import { useUserData } from '../../hooks/useUserData/useUserData';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useCommunityData } from '../../hooks/useCommunityData/useCommunityData';
import { Community } from '../../providers/CommunityProvider';
import { User } from '../../providers/UserProvider';

if (process.env.REACT_APP_LOCAL_DEV !== 'true') {
  awsConfigure(config);
}

export const App = () => {
  const { isDarkMode } = useDarkMode();
  const [theme, setTheme] = useState();

  const {
    user,
    isSignedIn,
    signIn,
    signOut,
    signUp,
    verify,
    resendConfirmationCode,
    forgotPassword,
    resetPassword,
  } = useAmplify();

  const { userData, mood, isUserLoading } = useUserData({
    userId: user?.id,
    jwt: user?.jwt,
  });

  const {
    feed,
    leaderboard,
    playlist,
    isFeedLoading,
    isLeaderboardLoading,
    isPlaylistLoading,
  } = useCommunityData({
    jwt: user?.jwt,
  });

  useEffect(() => {
    isDarkMode ? setTheme(darkTheme) : setTheme(defaultTheme);
  }, [isDarkMode]);

  if (!theme) {
    return;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Auth
        values={{
          user,
          isSignedIn,
          signIn,
          signOut,
          signUp,
          verify,
          resendConfirmationCode,
          forgotPassword,
          resetPassword,
        }}
      >
        <User values={{ userData, mood, isUserLoading }}>
          <Community
            values={{
              feed,
              leaderboard,
              playlist,
              isFeedLoading,
              isLeaderboardLoading,
              isPlaylistLoading,
            }}
          >
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Routes />
            </ThemeProvider>
          </Community>
        </User>
      </Auth>
    </LocalizationProvider>
  );
};
